import { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Chip, Grid, IconButton, TextField, Tooltip, tooltipClasses, Typography, useTheme } from "@mui/material"
import {showModal} from 'react-redux-modal-provider';
import { ButtonBasic, TableBasePaginado, TableLoadingComponent } from "../../components"
import ContactosService from "../../services/contactos.service";
import ModalConsultaContacto from "../../modals/consulta/ModalConsultaContacto";
import FechaFunction from "../../function/FechaFunction";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import SearchIcon from '@mui/icons-material/Search';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PersonIcon from '@mui/icons-material/Person';
import BadgeIcon from '@mui/icons-material/Badge';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import CategoryIcon from '@mui/icons-material/Category';
import FlagIcon from '@mui/icons-material/Flag';
import { styled } from '@mui/material/styles';
import ContactosAction from '../../store/actions/contactos';
import { connect } from "react-redux";

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.mode === 'dark' ? '#2d3a52' : theme.palette.common.white,
        color: theme.palette.mode === 'dark' ? '#e0e0e0' : 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 12,
    },
}));
const PotencialesClientesScreen = ({
    iniciarContacto,
    iniciarContrato,
    user
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [count, setCount] = useState(0);
    const [textSearch, setTextSearch] = useState('');
    const isInitialLoad = useRef(true);
    const searchTimeout = useRef(null);
    const navigate = useNavigate();

    const actualizar = (nroPagina = 1, limite = rowsPerPage, busqueda = textSearch) => {
        setLoading(true);
        ContactosService.getAll({
            type: 'multi',
            page: nroPagina,
            limit: limite,
            textSearch: busqueda
        }).then((r)=>{
            setItems(r?.data ?? r)
            setCount(r?.total ?? (r?.data ?? r)?.length ?? 0)
        }).finally(()=>setLoading(false));
    };
    const onChangePage = (nuevaPagina) => {
        setPage(nuevaPagina);
        actualizar(nuevaPagina + 1, rowsPerPage);
    };
    const onChangeRowsPerPage = (nuevoLimite) => {
        setRowsPerPage(nuevoLimite);
        setPage(0);
        actualizar(1, nuevoLimite);
    };
    const onClickNuevo = (empresa) => {
        iniciarContacto(null)
        iniciarContrato(null)
        navigate(`/contactos/nuevo${empresa}`);
    };
    const onClickVender = (idCliente) => {
        const item = items.find((it)=> it.id_c === idCliente)
        const id = item.contxemp?.find(a => a.empresaId_cxe === 1 );
        item.id_cxe = id.id_cxe;
        item.categoria_cxe = id.categoria_cxe;
        navigate('/contactos/nuevonubi',{state:{item:item, tipo: 'Contacto'}});
    }
    const onOpenVer = (idCliente) => {
        const item = items.find((it)=> it.id_c === idCliente)
        if(item?.cuentaNubi_c){
            return navigate(`/contactos/${item?.cuentaNubi_c}/cuenta`,{state:{item:item}});
        }
        if(item?.nubicom){
            navigate(`/contactos/${item.id_c}/nubicom`,{state:{item:item}});
        }else if(item?.strong){
            navigate(`/contactos/${item.id_c}/strong`,{state:{item:item}});
        }else if(item?.ids){
            navigate(`/contactos/${item.id_c}/ids`,{state:{item:item}});
        }
        return ''
    }
    const onModalConsultaNubi = (item) =>{
        const id = item.contxemp?.find(a => a.empresaId_cxe === 1 );
        item.id_cxe = id.id_cxe;
        showModal(ModalConsultaContacto, {item: item, nueva: true});
    }
    const columns = [
        {
            name: "id_c",
            label: "ID",
            options: {
                filter: false,
                sort: false,
                display:false,
                viewColumns: false
            }
        },
        {
            name: "createdAt",
            label: "Registrado",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <Box display='flex' alignItems='center' gap={1}>
                        <CalendarTodayIcon fontSize="small" sx={{color: isDarkMode ? '#90caf9' : '#012a6b'}} />
                        {FechaFunction.format(value,'dd/MM/yyyy')}
                    </Box>
                )
            }
        },
        {
            label: "Nombre",
            name: "nombreCompleto_c",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <Box display='flex' alignItems='center' gap={1}>
                        <PersonIcon fontSize="small" sx={{color: isDarkMode ? '#90caf9' : '#012a6b'}} />
                        {value}
                    </Box>
                )
            }
        },
        {
            name: 'documento_c',
            label: "Documento",
            options: {
                filter: false,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const item = items.find((it)=> it.id_c === tableMeta.rowData[0]);
                    let texto = 'Sin Dato';
                    if(value){
                        if(item?.tipoDoc_c === '96'){
                            texto = `DNI: ${value}`;
                        }else if(item?.tipoDoc_c === '80'){
                            texto = `CUIT: ${value}`;
                        }else{
                            texto = value;
                        }
                    }
                    return (
                        <Box display='flex' alignItems='center' gap={1}>
                            <BadgeIcon fontSize="small" sx={{color: isDarkMode ? '#90caf9' : '#012a6b'}} />
                            {texto}
                        </Box>
                    );
                }
            }
        },
        {
            name: 'celular_c',
            label: 'Teléfono',
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const item = items.find((it)=> it.id_c === tableMeta.rowData[0]);
                    const telefonos = [item?.celular_c, item?.telefono_c].filter(Boolean);
                    return (
                        <Box display='flex' alignItems='center' gap={1}>
                            <PhoneIcon fontSize="small" sx={{color: isDarkMode ? '#90caf9' : '#012a6b'}} />
                            {telefonos.length ? telefonos.join(' / ') : 'Sin Dato'}
                        </Box>
                    );
                }
            }
        }
        ,{
            label: 'Correo',
            name: 'email_c',
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <Box display='flex' alignItems='center' gap={1}>
                        <EmailIcon fontSize="small" sx={{color: isDarkMode ? '#90caf9' : '#012a6b'}} />
                        {value || 'Sin Dato'}
                    </Box>
                )
            }
        }
        ,{
            label: 'Categoria',
            name: 'categoria_cxe',
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <Box display='flex' alignItems='center' gap={1}>
                        {value || 'Sin Dato'}
                    </Box>
                )
            }
        }
        ,{
            label: 'Estado',
            name: 'estadoCliente_c',
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <Chip
                        label={value || 'Sin Dato'}
                        size="small"
                        sx={{
                            backgroundColor: isDarkMode ? '#64B5F6' : '#012a6b',
                            color: isDarkMode ? '#1F2A40' : '#fff',
                            fontWeight: 'bold'
                        }}
                    />
                )
            }
        },
        {
            name: 'actions',
            label: "Acciones",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <>
                        <Box display='flex'>
                            <LightTooltip  title="Perfil del Contacto" placement="top">
                                <IconButton color='primary' aria-label="ver" onClick={()=>onOpenVer(tableMeta.rowData[0])}>
                                    <AssignmentIndIcon fontSize="medium" sx={{color: isDarkMode ? '#64B5F6' : '#012a6b'}} />
                                </IconButton>
                            </LightTooltip>
                            <LightTooltip  title="Nueva Venta" placement="top">
                                <IconButton color='info' aria-label="edit" onClick={()=>onClickVender(tableMeta.rowData[0])}>
                                    <MedicalServicesIcon fontSize="medium" sx={{color: isDarkMode ? '#64B5F6' : '#012a6b'}} />
                                </IconButton>
                            </LightTooltip>
                        </Box>
                    </>
                )
            }
        }
    ];
    useEffect(() => {
        actualizar(1, rowsPerPage)
        document.title = `Potenciales Clientes`;
    }, [])

    useEffect(() => {
        if(isInitialLoad.current){
            isInitialLoad.current = false;
            return;
        }
        if(searchTimeout.current) clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(() => {
            setPage(0);
            actualizar(1, rowsPerPage, textSearch);
        }, 500);
        return () => clearTimeout(searchTimeout.current);
    }, [textSearch])
    const styleInput = useMemo(() => ({
        '& .MuiInputLabel-root':{
            color: isDarkMode ? '#e0e0e0' : '#000',
            borderRadius:20,
            fontSize: 15,
        },
        '& fieldset': {
            borderRadius: 2,
            border: 1,
            borderRadius:20,
            borderColor: isDarkMode ? '#3d4a62' : '#fff',
        },
        '& input::placeholder': {
            color: isDarkMode ? '#90a4ae' : undefined,
            opacity: 1,
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                border:1,
                borderRadius:20,
                color: isDarkMode ? '#e0e0e0' : '#000',
                borderColor: isDarkMode ? '#64B5F6' : '#fff'
            },
            '&:hover':{
                border: 1,
                borderRadius:20,
                background: isDarkMode ? '#2d3a52' : '#fff',
                borderColor: isDarkMode ? '#64B5F6' : '#fff',
                boxShadow: 3
            },
            '&.Mui-focused': {
                '&:hover':{
                    background: isDarkMode ? '#2d3a52' : '#fff',
                    borderRadius:20,
                    border:0
                }
            },
            background: isDarkMode ? '#2d3a52' : '#fff',
            color: isDarkMode ? '#e0e0e0' : '#000',
            borderRadius:20,
            height: 35,
            boxShadow: 4
        }
    }), [isDarkMode])
    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto', backgroundColor: isDarkMode ? '#1F2A40' : '#fff'}} className='side'>
            <Grid container p={4}>
                <Grid item xs={12} md={6} lg={6}>
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold'}} variant="h2">Potenciales Clientes</Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={6} sx={{display: 'flex', justifyContent: 'end'}}>
                    <ButtonBasic
                        textButton="NUEVO"
                        sx={{width: 200, height: 30, color: '#fff'}}
                        onClick={()=>onClickNuevo('nubi')}
                        variant='wk'
                        color='nextStep'
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={6} mt={2} mb={2}>
                    <TextField
                        size="small"
                        fullWidth
                        placeholder="Buscar por nombre, documento o celular"
                        value={textSearch}
                        sx={styleInput}
                        onChange={(e)=>setTextSearch(e.target.value)}
                        InputProps={{
                          startAdornment: <SearchIcon sx={{ mr: 1, color: isDarkMode ? '#90caf9' : '#012a6b' }} />
                        }}
                    />
                </Grid>
                <Grid item xs={12} sx={{marginBottom: 15}}>
                    {loading ? (
                        <TableLoadingComponent />
                    ) : (
                        <TableBasePaginado
                            title='Resultados'
                            columns={columns}
                            data={items}
                            count={count}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            onChangePage={onChangePage}
                            onChangeRowsPerPage={onChangeRowsPerPage}
                        />
                    )}
                </Grid>
            </Grid>
        </Box>
    )
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    iniciarContacto: (data) => dispatch(ContactosAction.iniciarContacto(data)),
    iniciarContrato: (data) => dispatch(ContactosAction.iniciarContrato(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PotencialesClientesScreen);